import React from 'react';
import PropTypes from 'prop-types';
import linkGreenIcon from 'assets/images/icons/link-green.svg';
import InfoTooltip from 'components/common-components/InfoTooltip';
import infoCircleGreyIcon from 'assets/images/icons/info-circle.svg';
import { FONT_FAMILY_MAP, resolveConditionalColor } from '../utils';

const StatsChartComponent = ({ widget, data }) => {
  const { basicProps, advancedProps } = widget;

  const valueFontFamily = FONT_FAMILY_MAP[advancedProps.formattingFontWeight] || '';

  const roundIfDecimal = (num) => {
    if (num % 1 !== 0) return num.toFixed(3);
    else return num;
  };

  return (
    <div className='d-flex flex-column justify-content-center align-items-center'>
      <div className='d-flex flex-grow-1 flex-column gap-1 justify-content-center align-items-center'>
        <label
          style={{
            color: advancedProps.textColor,
          }}
        >
          {basicProps.label}
        </label>
        <label
          style={{
            fontSize: advancedProps.formattingFontSize,
            fontFamily: valueFontFamily,
            color: resolveConditionalColor(data?.count ?? 0, advancedProps, '#000000'),
          }}
        >
          {roundIfDecimal(data?.count ?? 0)}
        </label>
        <div className='d-flex gap-2'>
          {advancedProps.tooltip && (
            <InfoTooltip
              text={advancedProps.tooltip}
              triggerElement={<img src={infoCircleGreyIcon} />}
            />
          )}
          {advancedProps.linkedPageId && (
            <img
              className='cursor-pointer'
              src={linkGreenIcon}
              onClick={() => {
                window.open(
                  `/dashboards/navigate/${advancedProps.linkedDashboardId}/${advancedProps.linkedPageId}`,
                  '_blank',
                );
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

StatsChartComponent.propTypes = {
  widget: PropTypes.object.isRequired,
  data: PropTypes.object,
};

export default StatsChartComponent;
